import ExclamationmarkTriangleFill from './ExclamationmarkTriangleFill';

export default ExclamationmarkTriangleFill;
